module.exports = __webpack_public_path__ + "static/media/bookmark.a91bf74a.svg";